var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"height":"100%"}},[(_vm.$route.path === '/link/enjoy')?_c('page',[_c('ZuiHeader'),_vm._v(" "),_c('SubPageTemplate',{attrs:{"page-title":"精彩体验","pageNav":false,"dynamically-tab":"","pid":_vm.pid,"sort-by":1,"default-tab-id":_vm.tabId,"page-size":10,"type":"experience"},on:{"article-click":_vm.articleClick}}),_vm._v(" "),_c('ZuiFooter')],1):_c('router-view')],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4ffb39b9","hasScoped":false,"buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/link/enjoy.vue
// module id = 1417
// module chunks = 0